import React from 'react';

type JobUnavailableProps = {
  jobPostData: any;
};

export const JobUnavailable = ({ jobPostData }: JobUnavailableProps) => {
  return (
    <div className='max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16'>
      <div className='text-center'>
        <div className='w-20 h-20 bg-gray-100 rounded-full flex items-center justify-center mx-auto mb-6'>
          <svg
              className='w-10 h-10 text-gray-400'
              fill='none'
              stroke='currentColor'
              viewBox='0 0 24 24'
          >
            <path
                strokeLinecap='round'
                strokeLinejoin='round'
                strokeWidth={2}
                d='M9.172 16.172a4 4 0 015.656 0M9 12h6m-6-4h6m2 5.291A7.962 7.962 0 0112 15c-2.34 0-4.5-1.006-6-2.709M15 17h5l-1.405-1.405A2.032 2.032 0 0118 14.158V11a6.002 6.002 0 00-4-5.659V5a2 2 0 10-4 0v.341C7.67 6.165 6 8.388 6 11v3.159c0 .538-.214 1.055-.595 1.436L4 17h5m6 0v1a3 3 0 11-6 0v-1m6 0H9'
            />
          </svg>
        </div>
        <h2 className='text-2xl font-bold text-gray-900 mb-3'>
          Job Post Unavailable
        </h2>
        <p className='text-lg text-gray-600 mb-6'>
          { jobPostData
            ? 'This job posting is currently inactive or has been removed.'
            : 'The requested job posting could not be found.' }
        </p>
        <p className='text-sm text-gray-500'>
          Please check back later or browse our other opportunities.
        </p>
      </div>
    </div>
  );
};
